import React, { useEffect } from 'react';
import Reveal from '../components/Reveal';

const Section = ({ title, children, i = 0 }) => (
  <Reveal delay={i * 0.05}>
  <div className="mb-8">
    <h2 className="font-display text-2xl sm:text-3xl text-[#1a1a1a] mb-3">{title}</h2>
    <div className="font-body text-[#4a463d] leading-relaxed space-y-3">{children}</div>
  </div>
  </Reveal>
);

const Terms = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div>
      <section className="bg-[#0b0b0b] py-20 sm:py-24 text-center">
        <p className="overline text-gold-gradient mb-3">The Fine Print</p>
        <h1 className="font-display text-5xl sm:text-6xl text-[#f7f3ec]">Terms &amp; Conditions</h1>
      </section>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <p className="font-body text-sm text-[#6b6459] mb-10">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</p>
        <Section title="Acceptance of Terms">
          <p>By accessing and shopping with Nikki’s Next Level Hair and Beauty, you agree to these Terms &amp; Conditions. If you do not agree, please do not use our site.</p>
        </Section>
        <Section title="Products & Pricing">
          <p>We strive for accuracy in product descriptions, images, and pricing. Colors may vary slightly due to screen settings and the natural nature of human hair. Prices are subject to change without notice.</p>
        </Section>
        <Section title="Orders">
          <p>All orders are subject to acceptance and availability. We reserve the right to refuse or cancel any order. You are responsible for providing accurate shipping and contact information.</p>
        </Section>
        <Section title="Shipping & Delivery">
          <p>Orders are typically dispatched within 48 hours. Delivery timelines are estimates and may vary. Free U.S. shipping applies to qualifying orders over $200.</p>
        </Section>
        <Section title="Returns">
          <p>Due to the intimate nature of hair products, items must be unused, unaltered, and in original packaging to be eligible for return. Please contact us within 7 days of delivery to start a return.</p>
        </Section>
        <Section title="Contact">
          <p>For any questions regarding these terms, email brooke.knight@nikkisnextlevel.com or call 1 (888) 989-1908.</p>
        </Section>
      </div>
    </div>
  );
};

export default Terms;
